import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserCircleIcon, LockClosedIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

const LoginPage: React.FC = () => {
  const { login, error, user, loading } = useAuth();
  
  // Если пользователь уже аутентифицирован, перенаправляем его
  if (!loading && user) {
    return <Navigate to="/" replace />;
  }
  const [formData, setFormData] = useState({
    login: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Предотвращаем повторную отправку
    if (isLoading) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      await login(formData.login, formData.password);
    } catch (err) {
      // Ошибка уже обрабатывается в AuthContext
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-2xl bg-primary text-primary-content mb-4">
            <UserCircleIcon className="h-10 w-10" />
          </div>
          <h2 className="text-center text-3xl font-bold text-base-content">
            Добро пожаловать
          </h2>
          <p className="mt-3 text-center text-base font-medium text-base-content/70">
            AgentB24 - Система управления агентами
          </p>
        </div>
        
        <div className="card bg-base-100 border border-base-300">
          <div className="card-body p-8">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="form-control">
                <label htmlFor="login" className="label">
                  <span className="label-text text-base font-semibold">Логин</span>
                </label>
                <input
                  id="login"
                  name="login"
                  type="text"
                  required
                  className="input input-bordered w-full bg-white text-lg"
                  placeholder="Введите логин"
                  value={formData.login}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-control">
                <label htmlFor="password" className="label">
                  <span className="label-text text-base font-semibold">Пароль</span>
                </label>
                <div className="relative">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    required
                    className="input input-bordered w-full bg-white text-lg pr-12"
                    placeholder="Введите пароль"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-base-content/50 hover:text-base-content transition-colors"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <EyeSlashIcon className="h-5 w-5" />
                    ) : (
                      <EyeIcon className="h-5 w-5" />
                    )}
                  </button>
                </div>
              </div>

              {error && (
                <div className="alert alert-error">
                  <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{error}</span>
                </div>
              )}

              <div className="form-control mt-8">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="btn btn-primary btn-lg w-full"
                >
                  {isLoading ? (
                    <>
                      <span className="loading loading-spinner loading-md"></span>
                      <span className="text-base font-semibold">Вход...</span>
                    </>
                  ) : (
                    <>
                      <LockClosedIcon className="h-6 w-6 mr-3" />
                      <span className="text-base font-semibold">Войти в систему</span>
                    </>
                  )}
                </button>
              </div>
            </form>


          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
